<template>
  <v-card class="app-card">
    <v-card-title class="app-card-title mb-0">
      <v-icon>manage_search</v-icon>Solicitação
    </v-card-title>
    <v-card-text class="app-card-content pl-0 pr-0">
      <v-stepper
        v-model="dadosForm.currentStep"
        outlined
        alt-labels
        class="app-stepper"
      >
        <v-stepper-header class="justify-center app-stepper-header">
          <div class="step-wrapper">
            <v-stepper-step
              :complete="dadosForm.currentStep > 1"
              step="1"
              class="step-item"
              color="primary"
            >
              Tipo de Solicitação
            </v-stepper-step>
          
            <v-stepper-step
              :complete="dadosForm.currentStep > 2"
              step="2"
              class="step-item"
              color="primary"
            >
              CPF
            </v-stepper-step>
          
            <v-stepper-step
              :complete="dadosForm.currentStep > 3"
              step="3"
              class="step-item"
              color="primary"
            >
              Biometria
            </v-stepper-step>
          
            <v-stepper-step
              :complete="dadosForm.currentStep > 4"
              step="4"
              class="step-item"
              color="primary"
            >
              Dados do Aluno
            </v-stepper-step>
          
            <v-stepper-step
              :complete="dadosForm.currentStep > 5"
              step="5"
              class="step-item"
              color="primary"
            >
              Solicitação Criada
            </v-stepper-step>
          </div>
        </v-stepper-header>
        
        <v-stepper-items>
          <v-stepper-content step="1">
            <TipoSolicitacao />
          </v-stepper-content>

          <v-stepper-content step="2">
            <FormConsultaCPF v-if="dadosForm.currentStep === 2" />
          </v-stepper-content>

          <v-stepper-content step="3">
            <Biometria context="sie"
              v-if="dadosForm.currentStep === 3"/>
            <v-row class="justify-end mr-4">
            <v-col :md="3" :sm="3" :xs="12" cols="12">
              <v-btn
                depressed
                block
                large
                text
                color="error"
                @click="cancelar"
              >Cancelar</v-btn
              >
            </v-col>
          </v-row>
          </v-stepper-content>

          <v-stepper-content step="4">
            <DocumentosForm v-if="dadosForm.currentStep === 4" />
          </v-stepper-content>

          <v-stepper-content step="5">
            <SolicitacaoCriada v-if="dadosForm.currentStep === 5" />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card-text>
  </v-card>
</template>

<script>
import FormConsultaCPF from "./FormConsultaCPF.vue";
import DocumentosForm from "./DocumentosForm.vue";
import { mapState, mapActions } from "vuex";
import TipoSolicitacao from "./TipoSolicitacao.vue";
import SolicitacaoCriada from "./SolicitacaoCriada.vue";
import Biometria from "@/components/Biometria/Biometria.vue";

const actions = mapActions("siePedidos", [
  "setFormStep",
  "setCPF",
  "setDadosFormSolicitacao",
]);
const state = mapState("siePedidos", ["dadosForm"]);

export default {
  name: "ConsultaCpf",
  components: {
    SolicitacaoCriada,
    FormConsultaCPF,
    DocumentosForm,
    TipoSolicitacao,
    Biometria
  },
  mounted() {
    this.setFormStep(1);
  },
  destroyed() {
    this.setCPF(null);
  },
  methods: {
    ...actions,
    cancelar(){
      this.setFormStep(1)
      this.setCPF(null)
    }
  },
  computed: {
    ...state,
  },
};

</script>

<style scoped>
.app-stepper-header {
  padding: 0 8px;
}

/* wrapper para alinhar e colocar separadores com CSS */
.step-wrapper {
  display: flex;
  align-items: center;
  gap: 8px; /* espaçamento entre passos */
}

/* cada passo recebe margem e um separador à direita (exceto o último) */
.step-item {
  margin: 0 6px;
  position: relative;
  padding-right: 18px;
}

/* separador fino entre passos */
.step-item:not(:last-child)::after {
  content: "";
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 2px;
  background: rgba(0,0,0,0.12);
  border-radius: 2px;
}

/* se quiser que o texto do step seja menor e mais compacto */
.app-stepper-header .v-stepper__label {
  font-size: 0.9rem;
}

/* ajuste responsivo para telas pequenas */
@media (max-width: 960px) {
  .step-wrapper {
    flex-wrap: wrap;     /* permite quebra de linha */
    justify-content: center;
  }

  .step-item {
    flex: 1 1 45%;        /* cada step ocupa ~metade da largura */
    padding-right: 0;
    margin-bottom: 8px;
  }

  .step-item::after {
    display: none;        /* remove separadores no modo mobile */
  }
}

</style>

<style scoped>
.app-stepper-header {
  padding: 0 8px;
}

.step-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}


.step-item {
  margin: 0 6px;
  position: relative;
  padding-right: 18px;
}


.step-item:not(:last-child)::after {
  content: "";
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 2px;
  background: rgba(0,0,0,0.12);
  border-radius: 2px;
}

.app-stepper-header .v-stepper__label {
  font-size: 0.9rem;
}


@media (max-width: 960px) {
  .step-wrapper {
    flex-wrap: wrap;
    justify-content: center;
  }

  .step-item {
    flex: 1 1 45%;
    padding-right: 0;
    margin-bottom: 8px;
  }

  .step-item::after {
    display: none;
  }
}
</style>